/***** Begin Set Up Global Pub/Sub Functionality *****/
var globalEvents = {

    events: {},

    Event: function (id) {
        var callbacks, method,
            event = id && globalEvents.events[id];

        if (!event) {
            callbacks = jQuery.Callbacks();
            event = {
                publish: callbacks.fire,
                subscribe: callbacks.add,
                unsubscribe: callbacks.remove
            };
            if (id) {
                globalEvents.events[id] = event;
            }
        }
        return event;
    }
};

/***** End Set Up Global Pub/Sub Functionality *****/

function fnc() {
    var result = {
        "c": "" + document.cookie.replace(/(?:(?:^|.*;\s*)MYA.1030\s*\=\s*([^;]*).*$)|^.*$/, "$1") + ""
    };

    return result;
}

var sst = false;
window.sfnc = function () {

    this.sst = true;

}



/***** Published Event List *****/
// This is a list of global events that are published by various components
// Please list new events in alphabetical order

// agentListCleared
// - Parameters: none
// - 1-Common.js (bsCommon.clearAgents)
// - Fired when local storage is cleared of the agent list

// agentListUpdated
// - Parameters: none
// - 1-Common.js (bsCommon.retrieveAgents)
// - Fired when a new list of agents is retrieved from the server

// agentReviewRetrieved
// - Parameters: agentNumber
// - 1-Common.js (bsCommon.retrieveAgentReview)
// - Fired when an agent review request has been received, passes back the agent number for the review

// locationUpdated
// - Parameters: none
// - bsEditLocation.js (bsEditLocationOverlay.submitZipCodeUpdate)
// - Fired when the user updates their zip code using the edit location overlay

// userLocationUpdated
// - Parameters: none
// - 1-Common.js (bsCommon.retrieveUserLocation)
// - Fired when the user's location is retrieved from an Ajax call

/***** Published Event List *****/



// Show body after page load.
$(function () {
    $('body').animate({ opacity: '1' }, 'fast').css('visibility', 'visible');
});



/***** Begin bsCommon Scripts *****/

var bsCommon = {

    isLocalStorageAvailable: false,
    userLocation: null,
    agentListJson: null,
    agentReviewsRequested: [],
    HasAFOAgentsLoaded: false,
    HasANYAgentsLoaded: false,
    isValidationScriptGLoaded: false,
    isValidationScriptSLoaded: false,

    init: function () {
        bsCommon.loadValidationCode();

        try {
            localStorage.setItem('test', 'test');
            localStorage.removeItem('test');

            bsCommon.isLocalStorageAvailable = true;
        }
        catch (e) {
            bsCommon.isLocalStorageAvailable = false;
        }

        globalEvents.Event("locationUpdated").subscribe(function () { bsCommon.clearAgents(); bsCommon.clearUserLocation(); });

        bsCommon.retrieveUserLocation();

        $(window).on("scroll", function () {
            $.data(this, "scrollCheck", setTimeout(function () {
                bsCommon.displayBackToTopArrow(true);
            }, 250));
        });

        //$(window).on("load", function()
        //{
        //  bsCommon.retrieveAnalyticsInformation();
        //});

        if (!$.fn.dialog) {
            $.fn.dialog = function () { };
        }
    },

    isImageOk: function (img) {
        if ((!img.complete) || ((typeof img.naturalWidth !== "undefined" && img.naturalWidth <= 1) && (img.src.indexOf("data") < 0))) {
            return false;
        }

        return true;
    },

    backToTop: function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        setTimeout(bsCommon.displayBackToTopArrow(true), 1500);
        return false;
    },

    displayBackToTopArrow: function (animate) {
        if (($(window).width() <= 992) && ($('html, body' + ":animated").length <= 1)) {
            $('.top').stop(true, false);

            if (($('html').scrollTop() > ($(window).height() / 2)) || ($('body').scrollTop() > ($(window).height() / 2))) {
                if (animate) {
                    $('.top').fadeIn(500);
                }
                else {
                    $('.top').show();
                }
            }
            else {
                if (animate) {
                    $('.top').fadeOut(500);
                }
                else {
                    $('.top').hide();
                }
            }
        }
    },

    restrictCharactersText: function (allowNumbers, e) {
        var text;

        if ((e.keyCode === 8) || (e.keyCode === 9)) {
            return true;
        }
        if (e.keyCode !== 0) {
            text = e.keyCode;
        }
        else if (e.charCode !== 0) {
            text = e.charCode;
        }

        if ((text === 8) || ((text >= 33) && (text <= 44))) {
            return false;
        }

        if (allowNumbers) {
            return /^[a-zA-Z0-9-\-.\s]$/.test(String.fromCharCode(text));
        }
        else {
            return /^[a-zA-Z-\-.\s]$/.test(String.fromCharCode(text));
        }
    },

    readCookie: function (cookieName) {
        cookieName = cookieName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(cookieName) === 0) {
                return c.substring(cookieName.length, c.length);
            }
        }

        return "";
    },

    deleteCookie: function (cookieName) {
        document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    clearAgents: function () {
        bsCommon.agentListJson = null;

        if (bsCommon.isLocalStorageAvailable) {
            localStorage.removeItem("commonAgents");
            localStorage.removeItem("commonAgentsExpires");
        }

        globalEvents.Event('agentListCleared').publish();
    },

    retrieveAnalyticsInformation: function () {
        $.ajax({
            url: "/anon/handlers/ajaxactivity.ashx?Method=RequestAnalyticsInformation",
            async: true,
            success: function (result) {
                $("#pageBottom").html(result + $("#pageBottom").html());
            },
            error: function (request, status, error) {
            }
        });
    },

    retrieveUserLocation: function () {
        var myUserLocation = null;

        if (bsCommon.isLocalStorageAvailable) {
            myUserLocation = localStorage.getItem("userLocation");
        }

        if ((myUserLocation === null) || (bsCommon.readCookie("AMS_300") !== "") || (Date.now() >= Date.parse(JSON.parse(myUserLocation).DataExpiration))) {
            $.ajax({
                url: "/anon/handlers/ajaxactivity.ashx?Method=JsonUserLocation",
                async: true,
                success: function (result) {
                    myUserLocation = result;

                    if (myUserLocation) {
                        bsCommon.userLocation = myUserLocation;

                        if (bsCommon.isLocalStorageAvailable) {
                            localStorage.setItem("userLocation", myUserLocation);
                        }

                        bsCommon.deleteCookie("AMS_300");

                        globalEvents.Event('userLocationUpdated').publish(myUserLocation);
                    }
                },
                error: function (request, status, error) {
                }
            });
        }
        else {
            bsCommon.userLocation = myUserLocation;
        }
    },

    userLocationJson: function () {
        return JSON.parse(bsCommon.userLocation);
    },

    clearUserLocation: function () {
        bsCommon.userLocation = null;
        localStorage.removeItem("userLocation");
    },

    retrieveAgents: function () {
        bsCommon.agentListJson = null;

        if (bsCommon.isLocalStorageAvailable) {
            var myLocalAgents = localStorage.getItem("commonAgents");
            var myLocalAgentsExpires = localStorage.getItem("commonAgentsExpires");

            if ((myLocalAgentsExpires !== null) && (Date.now() < myLocalAgentsExpires) && (myLocalAgents !== null) && (myLocalAgents !== '{"Agents":null,"AgentListType":2}')) {
                bsCommon.agentListJson = myLocalAgents;
                AgentFlyoutJS.agentCallBack(myLocalAgents);
            }
        }

        if (bsCommon.agentListJson === null) {
            $.ajax({
                url: "/anon/handlers/ajaxactivity.ashx?Method=JsonAgentList",
                async: true,
                success: function (result) {
                    if (!Date.now) {
                        Date.now = function () { return new Date().getTime(); }
                    }

                    var myNumDays = 2;
                    var myExpiresTimestamp = Date.now() + (myNumDays * 24 * 3600 * 1000);

                    if (bsCommon.isLocalStorageAvailable) {
                        localStorage.setItem("commonAgentsExpires", myExpiresTimestamp);
                        localStorage.setItem("commonAgents", result);
                    }

                    bsCommon.agentListJson = result;
                    if (AgentFlyoutJS.isAgentFlyoutCall === true) {
                        AgentFlyoutJS.agentCallBack(result);
                        AgentFlyoutJS.isAgentFlyoutCall = false;
                    }
                    else {
                        globalEvents.Event('agentListUpdated').publish(result);
                    }
                },
                error: function (request, status, error) {
                    bsCommon.clearAgents();
                }
            });
        }

        return bsCommon.agentListJson;
    },

    retrieveAgentReview: function (agentNumber) {
        var agentReviewRequested = false;

        bsCommon.agentReviewsRequested.forEach(function (item, index, array) {
            if (item === agentNumber) {
                agentReviewRequested = true;
            }
        });

        if (!agentReviewRequested) {
            bsCommon.agentReviewsRequested.push(agentNumber);

            $.ajax({
                type: "GET",
                url: "https://allstate.reviewability.com/reviews/as-" + agentNumber + ".0.json",
                contentType: "text/plain",
                dataType: "json",
                async: true,
                crossDomain: true,
                timeout: 5000,
                headers: null
            })
                .done(function (data) {
                    bsCommon.createReviewDiv(agentNumber, data, false);
                })
                .fail(function (data) {
                    bsCommon.createReviewDiv(agentNumber, null, true);
                })
                .always(function (data) {
                    globalEvents.Event("agentReviewRetrieved").publish(agentNumber);
                });
        }
    },

    createReviewDiv: function (agentNumber, reviewData, createDefaultDiv) {
        if ((reviewData === undefined) || (createDefaultDiv)) {
            reviewData = { total: 0, average: 0 };
        }

        reviewDiv = "<div class='AgentReviews reviews-" + agentNumber + "'>";

        for (var b = "", c = Math.floor(reviewData.average), d = 0; c > d; d += 1) {
            reviewDiv += "<span class='star full'>&nbsp;</span>";
        }

        1 === Math.ceil(reviewData.average - Math.floor(reviewData.average)) && (reviewDiv += "<span class='star half'>&nbsp;</span>");

        for (var e = 5 - Math.ceil(reviewData.average), f = 0; e > f; f += 1) {
            reviewDiv += "<span class='star empty'>&nbsp;</span>";
        }

        reviewDiv += "<span class='count'>";
        reviewDiv += reviewData.total;
        reviewDiv += "</span>";
        reviewDiv += "<span class='count reviewText'>&nbsp;</span>";
        reviewDiv += "</div>";

        $('body').append(reviewDiv);
    },

    loadValidationCode: function () {
        if (window.location.hostname.indexOf(".allstate.com") >= 0 && window.location.hostname.indexOf("allstateni") < 0) {
            if (document.cookie.indexOf('MYA.1030=') < 0) {
                var dateNow = new Date();
                var cookieValue = "";

                cookieValue = cookieValue + (Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000);
                cookieValue = cookieValue + "-";
                cookieValue = cookieValue + (Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000);
                cookieValue = cookieValue + "-";
                cookieValue = cookieValue + (Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000);
                cookieValue = cookieValue + "-";
                cookieValue = cookieValue + (Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000);
                cookieValue = cookieValue + "-";
                cookieValue = cookieValue + (Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000);
                cookieValue = cookieValue + (Math.floor(Math.random() * (999999999 - 100000000 + 1)) + 100000000);
                cookieValue = cookieValue + "-";
                cookieValue = cookieValue + ("00" + dateNow.getMinutes()).slice(-2);
                cookieValue = cookieValue + ("000" + dateNow.getMilliseconds()).slice(-2);

                document.cookie = "MYA.1030=" + cookieValue + ";path=/;domain=.allstate.com;secure";
            }

            var account = "5290011";

            if (window.location.hostname.indexOf("-") < 0) {
                account = "529001";
            }

            (function () {
                var f = document, e = window, i = e.location.protocol, b = [["src", [i === "https:" ? "https:/" : "http:/", "data.allstate.com/" + account + "/spal.js?r=" + Math.random()].join("/")], ["type", "text/javascript"], ["async", true]], c = f.createElement("script"), h = f.getElementsByTagName("head")[0]; setTimeout(function () {
                    for (var d = 0, l = b.length; d < l; d++) { c.setAttribute(b[d][0], b[d][1]); }
                    c.addEventListener('load', function (e) { bsCommon.isValidationScriptSLoaded = true; bsCommon.callValidationCallback(); }, false);
                    h.appendChild(c);
                }, 0);
            })();

            (function (d, f) {
                var b =
                    { src: (d.location.protocol === "https:" ? "https:" : "http:") + "//data.allstate.com/" + account + "/gangly.js?r=" + Math.random(), async: true, type: "text/javascript" }
                    , c = f.createElement("script"), h = f.getElementsByTagName("head")[0]; setTimeout(function () {
                        for (var e in b) { c.setAttribute(e, b[e]); }
                        c.addEventListener('load', function (e) { bsCommon.isValidationScriptGLoaded = true; bsCommon.callValidationCallback(); }, false);
                        h.appendChild(c);
                    }, 0);
            })(window, document);
        }
    },

    callValidationCallback: function () {
        if (bsCommon.isValidationScriptSLoaded) {
            valCallbackDelay = setTimeout(window['spac']('login'), 250);
        }
    }
};

bsCommon.init();

/***** End bsCommon Scripts *****/